// extracted by mini-css-extract-plugin
export default {"mainContainer":"Transfer_mainContainer__lK+yM","container":"Transfer_container__UKM-c","content":"Transfer_content__Nkzob","field":"Transfer_field__8C0kA"};